import { render, staticRenderFns } from "./ReportMenuSummarySectionData.vue?vue&type=template&id=f19752a0&"
import script from "./ReportMenuSummarySectionData.vue?vue&type=script&lang=js&"
export * from "./ReportMenuSummarySectionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f19752a0')) {
      api.createRecord('f19752a0', component.options)
    } else {
      api.reload('f19752a0', component.options)
    }
    module.hot.accept("./ReportMenuSummarySectionData.vue?vue&type=template&id=f19752a0&", function () {
      api.rerender('f19752a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/report/ReportMenu/ReportMenuSummarySection/ReportMenuSummarySectionData.vue"
export default component.exports